/*global angular*/
/*global jQuery*/
/*global _*/

import app from '../../../main/apt';

app.controller('CreateClinkCtrl', [	
	'$scope', '$log', '$localStorage', '$uibModal', '$uibModalInstance', '$filter', 
	'AppHelper', 'ngDialog', 
	'app', 'campaigns', 'allCampaigns', 'clinks', 'existingClink', '$q',
	function(
	$scope, $log, $localStorage, $uibModal, $uibModalInstance, $filter, 
	AppHelper, ngDialog, 
	app, campaigns, allCampaigns, clinks, existingClink, $q
) {

  $scope.$storage        = $localStorage;

  $scope.app = app;
  $scope.appID           = app.appID;
  $scope.androidApp      = app.appID.indexOf('.') !== -1;
  $scope.appTitle        = app.title;
  $scope.appIcon         = app.icon;

  $scope.campaigns       = campaigns;
  $scope.allCampaigns    = allCampaigns;
  $scope.clinks          = clinks;
  $scope.existingClink   = existingClink;

  $scope.countryTags     = [];
  $scope.platforms       = {};
  $scope.ignorePlatforms = false;
  $scope.special         = {};

  $scope.allowCounterBidOverride = 'default';
  $scope.allowCounterBid         = 'default';

  $scope.current_user = window.current_user;

  $scope.payouts = {
      minPayout : null,
      p2p: null
  };
  
  $scope.extra = {
	  dailyCap : null
  };
  
  $scope.all = {
      selected : true,
	  countryTags : '',
	  payout : 0.0,
	  dailyCap : null,
	  android : false,
	  iphone : false,
	  ipad : false
  };
  
  $scope.existingClinkUpdate = null;
  $scope.defaultReachPartnerSplit = 0.7;
  $scope.reachPartners = [];
  $scope.existingCLinks = [];
  $scope.campaignSummary = {
		  numberOfCampaigns : 0,
		  platforms : 'None',
		  countries : 'None',
		  totalCap : 'None',
		  minPayout : 0,
		  maxPayout : 0,
		  payoutRange : 'None',
	      osVersion : 'None',
	      incent : false
  };

  $scope.clinkAssignableUsers = [];

  $scope.init = function() {
  	  var deferred = $q.defer();
  	  
  	  // If an existing clink is given, then use the "existingClinkUpdate" to hold any updates that need to be saved.
  	  if ( $scope.existingClink ) {
  		  $scope.existingClinkUpdate = {
  		      p2p : 0.0,
  		      daily_cap : 0,
  		      android : false,
  		      iphone : false,
  		      ipad : false,
  		      countries : null,
  		      allCountries : false,
  		      split : 0.0
  		  };
  	  }
  	  
	  $scope.loadingConfigs = true;
	  AppHelper.getPublishersFull( { clinkable: 'true' },
		  function(data) {
		  	 $scope.$storage.publishers = data;
		     $scope.initReachPartners( data );
	  	  },
	  	  function() {
			$scope.loadingConfigs = false;
			deferred.reject();
			  $scope.message = 'Could not get publisher/site configurations';
		      ngDialog.open({
		    	  template: 'static/dialogs/error.html',
		    	  scope: $scope
		      });
	  	  },
	  	  function() {
	  		  // If there is only 1 campaign, the go ahead and pre-select it.  Ensure UI is refreshed with this update.
	  		  // Don't select if its a reach-denied campaign since the user has to explicitly opt-in for this type of campaign.
	  		  if ( $scope.campaigns && $scope.campaigns.length === 1 ) {
	  			  $scope.campaigns[0].added = true;
	  			  $scope.updateReachPartnerConfigsAndCampaignSummary();
    	  	  	  $scope.$apply();
	  		  }
	  		  
	  		  $scope.loadingConfigs = false;
			  $scope.updateReachPartnerOwners();
	  		  deferred.resolve();
	  	  }
	  );

	  $scope.loadingClinkAssignableUsers = true;
	  AppHelper.getClinkAssignableUsers( {},
	      function( data ) {
		      $scope.initClinkAssignableUsers( data );
		  },
		  function() {
			$scope.loadingClinkAssignableUsers = false;
			deferred.reject();
			$scope.message = 'Could not get users for Clink ownership';
			ngDialog.open( {
				template: 'static/dialogs/error.html',
				scope: $scope
		  	} );
	  	  },
	  	  function() {
			$scope.loadingClinkAssignableUsers = false;
			$scope.updateReachPartnerOwners();
			deferred.resolve();
		}
	  );

	  // ensure no campaigns are added from a previous clink creation.  this can happen if page is not reloaded before making a new clink
	  // Also check if there are reach-denied campaigns in the list.
	  $scope.campaigns = $scope.campaigns.map( function( camp ) {
	  	  camp.added = false;
	  	  return camp;
	  });
	  
	  return deferred.promise;
  };

  $scope.updateReachPartnerOwners = function() {
	  // Wait until both publisher/reachPartner and assignable click users have been fetched and processed.
	  if ( $scope.loadingConfigs || $scope.loadingClinkAssignableUsers ) {
		  return;
	  }

	  // Check if the current user is an assignable user.  Also, for any assignable users that have allowedPlacements, map the allowed 
	  // placements to the corresponding user.  Any reach partner who's pub:site ID are in this map will be assigned to that user.
	  var isCurrentUserAssignable = false;
	  var usersForPlacements = {};
      for ( let i = 0; i < $scope.clinkAssignableUsers.length; i++ ) {
		  var user = $scope.clinkAssignableUsers[i];

		  if ( $scope.current_user['loginEmail'] === user['loginEmail'] ) {
			isCurrentUserAssignable = true;
		  }

		  if ( user['allowedPlacements'] ) {
			  for ( let j = 0; j < user['allowedPlacements'].length; j++ ) {
				usersForPlacements[user['allowedPlacements'][j]] = user;
			  }
		  }
	  }

	  for ( let i = 0; i < $scope.reachPartners.length; i++ ) {
		  var userForPartner = null;
		  var partner = $scope.reachPartners[i];

		  // Check if this reach partner is managed by a particular user.  First check at publisher level, then at site level.
		  if ( partner.publisherID + ":***" in usersForPlacements ) {
			  userForPartner = usersForPlacements[partner.publisherID + ":***"];
		  }
		  else if ( partner.publisherID + ":" + partner.siteID in usersForPlacements ) {
		  	  userForPartner = usersForPlacements[partner.publisherID + ":" + partner.siteID];
		  }
		  else if ( isCurrentUserAssignable ) {
			  userForPartner = $scope.current_user
		  }

		  if ( userForPartner ) {
			  $scope.reachPartners[i].owner = userForPartner['loginEmail'];
		  }
		  else {
			  $scope.reachPartners[i].owner = "notset";
		  }
	  }
  }

  $scope.initClinkAssignableUsers = function( data ) {
	  $scope.clinkAssignableUsers = data['users'];
  };
    
  $scope.initReachPartners = function( data ) {
	  for ( var key in data ) {
		  var partner = data[key];
		  
		  var reachPartner = {};
		  reachPartner.name = partner.publisherName;
		  reachPartner.publisherID = partner.publisherID;
		  reachPartner.siteID = partner.siteID;
		  reachPartner.countries = '';
		  reachPartner.payout = 0.0;
		  reachPartner.split = partner.publisherRevShare;
		  reachPartner.cap = 0;
		  reachPartner.android = false;
		  reachPartner.iphone = false;
		  reachPartner.ipad = false;
		  reachPartner.included = false;
		  reachPartner.stats = partner.stats;
		  reachPartner.owner = "notset";  // Owner will be updated once the publishers and clink assignable users have been fetched and processed.
		  reachPartner.userevshare = false;
		  
		  // Determine which existing clinks exist for this reach partner.
	      if ( $scope.clinks && $scope.clinks.length > 0 ) {
	    	  for ( let i = 0; i < $scope.clinks.length; i++ ) {
	    		  if ( reachPartner.publisherID === $scope.clinks[i].pub_id && reachPartner.siteID === $scope.clinks[i].site_id ) {
	    			  $scope.clinks[i].pub_name = reachPartner.name;
	    			  $scope.existingCLinks.push( $scope.clinks[i] );
	    		  }
	    	  }
	      }
		  
		  $scope.reachPartners.push( reachPartner );
		  
		  // For an existing clink, find the partner's split from a reach partner config.
		  if ( $scope.existingClinkUpdate && ( $scope.existingClink.pub_id === reachPartner.publisherID ) && ( $scope.existingClink.site_id = reachPartner.siteID ) ) {
			  $scope.existingClinkUpdate.split = reachPartner.split;
		  }
	  }
	  
	  // Ensure the UI is up to date with the updated model.
	  $scope.$apply();
  };
          
  $scope.isDailyCapForCLink = function( clink ) {
	  return ( clink.configs && clink.configs.length > 0 && clink.configs[0].daily_cap && clink.configs[0].daily_cap > 0 );
  };
  
  $scope.updateExistingClinkMargin = function() {
	  $scope.existingClinkUpdate.margin = $scope.determineMarginInfo( null, $scope.existingClinkUpdate.p2p, $scope.campaignSummary.minPayout, $scope.campaignSummary.maxPayout ) + " Margin";
  };
  
  $scope.updateReachPartnerMargin = function( reachPartner ) {
	  reachPartner.margin = $scope.determineMarginInfo( null, reachPartner.payout, $scope.campaignSummary.minPayout, $scope.campaignSummary.maxPayout );  
  };

  $scope.getReachPartnerRevShare = function( reachPartner ) {
	  return $scope.determineRevShareInfo( reachPartner.split, $scope.campaignSummary.minPayout, $scope.campaignSummary.maxPayout );
  }
  
  $scope.updateReachPartnerData = function( type, selectedMinPayout, selectedMaxPayout ) {
	  // Update the existing clink update object only if it exists.
	  if ( $scope.existingClinkUpdate ) {
		  $scope.existingClinkUpdate.p2p = ( $scope.all.payout * $scope.existingClinkUpdate.split ).toFixed( 2 ); 
		  $scope.existingClinkUpdate.margin = $scope.determineMarginInfo( null, $scope.existingClinkUpdate.p2p, $scope.campaignSummary.minPayout, $scope.campaignSummary.maxPayout )  + " Margin";
		  $scope.existingClinkUpdate.countries = $scope.convertCountriesToTags( $scope.all.countryTags );
		  $scope.existingClinkUpdate.daily_cap = $scope.all.dailyCap;
		  $scope.existingClinkUpdate.android = $scope.all.android;
		  $scope.existingClinkUpdate.iphone = $scope.all.iphone;
		  $scope.existingClinkUpdate.ipad = $scope.all.ipad;
		  return;
	  }
	  
	  var t = 0;
	  if ( type === "payout" )        t = 1;
	  else if ( type === "country" )  t = 2;
	  else if ( type === "cap" )      t = 3;
	  else if ( type === "android" )  t = 4;
	  else if ( type === "iphone" )   t = 5;
	  else if ( type === "ipad" )     t = 6;
	  
	  if ( t === 1 ) {
		  $scope.all.margin = $scope.determineMarginInfo( null, $scope.all.payout, $scope.campaignSummary.minPayout, $scope.campaignSummary.maxPayout );
	  }
	  
	  // Now update all the reach partner data.
	  for ( let i = 0; i < $scope.reachPartners.length; i++ ) {
		  if ( t === 1 ) {
			  $scope.reachPartners[i].payout = $scope.all.payout;
			  $scope.reachPartners[i].margin = $scope.determineMarginInfo( null, $scope.reachPartners[i].payout, $scope.campaignSummary.minPayout, 
				  $scope.campaignSummary.maxPayout );
		  }
		  else if ( t === 2 ) $scope.reachPartners[i].countries = $scope.all.countryTags;
		  else if ( t === 3 ) $scope.reachPartners[i].cap = $scope.all.dailyCap;
		  else if ( t === 4 ) {
			  $scope.all.android = document.getElementById( "all-checkbox-android" ).checked;
			  $scope.reachPartners[i].android = $scope.all.android;
		  }
		  else if ( t === 5 ) {
			  $scope.all.iphone = document.getElementById( "all-checkbox-iphone" ).checked;
			  $scope.reachPartners[i].iphone = $scope.all.iphone;
		  }
		  else if ( t === 6 ) {
			  $scope.all.ipad = document.getElementById( "all-checkbox-ipad" ).checked;
			  $scope.reachPartners[i].ipad = $scope.all.ipad;
		  }
		  else {
			  // When typing the payout in directly into the "all" payout field, that value is used "as is" for each reach partner (the case above)
			  // When selected a campaign, the then reach partner's split against the selected campaign's payout is used to determine payout.
			  $scope.reachPartners[i].payout = ( selectedMinPayout * $scope.reachPartners[i].split ).toFixed( 2 );
			  $scope.reachPartners[i].countries = $scope.all.countryTags;
			  $scope.reachPartners[i].cap = $scope.all.dailyCap;
			  $scope.reachPartners[i].android = $scope.all.android;
			  $scope.reachPartners[i].iphone = $scope.all.iphone;
			  $scope.reachPartners[i].ipad = $scope.all.ipad;
			  $scope.reachPartners[i].margin = $scope.determineMarginInfo( $scope.reachPartners[i].split, $scope.reachPartners[i].payout, selectedMinPayout, selectedMaxPayout ); 
		  }
	  }
  };
  
  $scope.determineMarginInfo = function( split, payout, minCPI, maxCPI ) {
	  // Determine the margin info text which can show either a single value or a range.
	  var marginPercentage;
	  if ( split != null ) {
		  marginPercentage = $filter( 'percentage' )( 1.0 - split, 0 );
	  }
	  else {
		  marginPercentage = $filter( 'percentage' )( ( minCPI - payout ) / minCPI, 0 );
		  if ( minCPI !== maxCPI ) {
			  marginPercentage = marginPercentage + " - " + $filter( 'percentage' )( ( maxCPI - payout ) / maxCPI, 0 );
		  }
	  }
	  
	  var margin =  $filter( 'currency' )( ( minCPI - payout ), '$' );
	  if ( minCPI !== maxCPI ) {
		  margin = margin + " - " + $filter( 'currency' )( ( maxCPI - payout ), '$' );
	  }
	  
	  if ( split != null ) {
		  return margin + " @ " + marginPercentage;
	  }
	  return margin + " (" + marginPercentage + ")";
  };

  $scope.determineRevShareInfo = function( revShare, minCPI, maxCPI ) {
	  if ( minCPI === maxCPI ) {
		  return $filter( 'currency' )( ( revShare * minCPI ), '$' ) + " @ " + $filter( 'percentage' )( revShare );
	  }
	  return $filter( 'currency' )( ( revShare * minCPI ), '$' ) + " - " + $filter( 'currency' )( ( revShare * maxCPI ), '$' ) + " @ " + $filter( 'percentage' )( revShare );
  }
      
  $scope.cancel = function () {
	  $uibModalInstance.dismiss('cancel');
  };
  
  $scope.isAndroidCampaigns = function() {
	  return ( $scope.campaigns[0].platforms.indexOf( 'android' ) >= 0 );
  };
  
  $scope.ok = function() {
	  $scope.errors = [];

	  // Validate the chosen campaigns and determine min payout and platforms.
	  var campaignAdded = false;
	  var invalidIncent = false;
	  var incentIncluded = false;
	  var nonIncentIncluded = false;
	  var minPayout = 1000.0;
	  
	  for (let i = 0; i < $scope.campaigns.length; i++) {
	      if ( $scope.campaigns[i].added ) {
	    	  campaignAdded = true;

	    	  var campaignPayout = $scope.campaigns[i].payout;
  			  if ( campaignPayout === "n/a" ) {
				  // Now allowing campaigns with no payout but are well defined CPC campaigns with a payout for click event.
				  if ( $scope.campaigns[i].knownEvents ) {
					  var knownEvents = $scope.campaigns[i].knownEvents;
					  for ( let j = 0; j < knownEvents.length; j++ ) {
					 	  if ( knownEvents[j].eventTypeCode === "CPC" && knownEvents[j].eventType === "CLICK" && knownEvents[j].eventSourceType === "FEED_WELL_DEFINED" && knownEvents[j].grossCPA && knownEvents[j].grossCPA > 0.0 ) {
					 		 campaignPayout = knownEvents[j].grossCPA;
						  }
					  }
				  }
  			  }
	    	  
	    	  minPayout = Math.min( minPayout, campaignPayout );
	    	  
	    	  // If incent cLink, can't allow non-incent campaigns.
	    	  if ( $scope.existingClink && $scope.existingClink.incent ) {
	    		  if ( !$scope.campaigns[i].incent ) {
	    			  invalidIncent = true;
	    		  }
	    	  }
	    	  
	    	  if ( $scope.campaigns[i].incent ) incentIncluded = true;
	    	  if ( !$scope.campaigns[i].incent ) nonIncentIncluded = true;
	      }
	  }
	  
	  if ( !campaignAdded ) {
		  $scope.errors.push( "No campaigns selected" );
	  }
	  	  
	  if ( invalidIncent ) {
		  $scope.errors.push( "A non-incent campaign cannot be added to an incent requested cLink." );
	  }
	  else if ( incentIncluded && nonIncentIncluded ) {
		  $scope.errors.push( "Cannot mix incent and non-incent campaigns." );
	  }
	  	  
	  var reachPartnerParams = null;
	  var existingClinkParams = null;
	  
	  if ( $scope.existingClinkUpdate ) {
		  var info = $scope.createAndValidateInfo();
		  if ( info.errors ) {
			  for ( let j = 0; j < info.errors.length; j++ ) {
				  $scope.errors.push( info.errors[j] );
			  }
		  }
		  else {
			  existingClinkParams = info;
			  
			  // Don't use the clinkID if its a system created clink which is a "fake" clink used for available offers.
			  if ( !$scope.existingClink.creator || $scope.existingClink.creator !== "system" ) {
				  existingClinkParams['clinkid'] = $scope.existingClink.clink_id;
			  }  	  
			  existingClinkParams['pubid'] = $scope.existingClink.pub_id;
			  existingClinkParams['siteid'] = $scope.existingClink.site_id;
		  }
	  }
	  else {
		  // Get and validate the reach partner cLink info.
		  var reachPartnerIncluded = false;
		  reachPartnerParams = [];
		  for ( let i = 0; i < $scope.reachPartners.length; i++ ) {
			  if ( $scope.reachPartners[i].included ) {
				  reachPartnerIncluded = true;
				  info = $scope.createAndValidateInfo( $scope.reachPartners[i] );
				  if ( info.errors ) {
					  for ( let j = 0; j < info.errors.length; j++ ) {
						  $scope.errors.push( info.errors[j] );
					  }
				  }
				  else {
					  reachPartnerParams.push( info );
				  }
			  }
		  }
		  
		  if ( !reachPartnerIncluded ) {
			  $scope.errors.push( "No reach partners selected" );
		  }
	  }
	  
	  if ( $scope.errors.length > 0 ) {
		  ngDialog.open({
			  template: 'static/dialogs/listErrors.html',
			  scope: $scope
		  });
	  } 
	  else {
		  var params = {
		    'appid': 	               $scope.appID,
		    'campids': 	               $scope.getCampaignIDs(),
		    'minPayout':               minPayout,
		    'allowIncent':             ( $scope.existingClink ? $scope.existingClink.incent : $scope.campaignSummary.incent ),
		    'ignorePlatforms':         $scope.ignorePlatforms,
			'allowCounterBidOverride': $scope.getAllowCounterBidOverride(),
			'allowCounterBid':         $scope.getAllowCounterBid(),
		  };
		  
		  if ( reachPartnerParams ) {
			  var clinkData = [];
			  for ( let i = 0; i < reachPartnerParams.length; i++ ) {
		          // The format of the clink data is: <pubID>,<siteID>,<countries as space delimited list>,platforms,payout,dailyCap,owner,useRevShare
				  var data = reachPartnerParams[i];
				  var value = data.pubID + "," + data.siteID + "," + data.countries.join( ' ' ) + "," + data.platforms + "," + data.payout + "," + data.dailyCap + "," + data.owner + "," + data.useRevShare;
				  clinkData.push( value );
			  }
			  
			  params['clink'] = clinkData;
	
			  AppHelper.addClinks( params, 
			    function( data ) {
				  var createdClinkIDs = [];
				  for ( let i = 0; i < data.length; i++ ) {
					  if ( data[i].created ) {
						  createdClinkIDs.push( data[i].clinkid );
					  }
				  }
				  
			      $uibModalInstance.close( createdClinkIDs );
			  	},
			  	function() {
			      ngDialog.open({
			    	  template: '<div>Sorry, there was a problem creating these clinks</div>',
			    	  plain: true
			      });
			  	}
			  );
		  }
		  else {
			  params["status"] = "ACTIVE";
			  
			  for ( var key in existingClinkParams ) {
				  params[key] = existingClinkParams[key];
			  }
			  
			  AppHelper.addClink( params, 
					    function( data ) {
					      $uibModalInstance.close( data.clinkid );
					  	},
					  	function() {
					      ngDialog.open({
					    	  template: '<div>Sorry, there was a problem updating this cLink</div>',
					    	  size: 'mod-clink-error',
					    	  plain: true
					      });
					  	}
					  );
		  }
	  }
  };
  
  $scope.getValidPlatforms = function( reachPartner ) {
	  if ( reachPartner.android ) {
		  return "android";
	  }
	  if ( reachPartner.iphone && reachPartner.ipad ) {
		  return "iphone ipad";
	  }
	  if ( reachPartner.iphone ) {
		  return "iphone";
	  }
	  if ( reachPartner.ipad ) {
		  return "ipad";
	  }
	  return null;
  };
    
  $scope.getValidCountries = function( countriesToCheck ) {
	  if ( !countriesToCheck || countriesToCheck.trim() === "" ) {
		  return null;
	  }
	  
	  if ( countriesToCheck === 'ALL_FIELDS' ) {
		  return countriesToCheck;
	  }
	  
	  var countryArray = countriesToCheck.split( /[\s,]+/ );
	  var countries = new Set();
	  
	  for ( let i = 0; i < countryArray.length; i++ ) {
		  // An individual country string must be exactly 2 letters.
		  if ( countryArray[i].length !== 2 || !countryArray[i].match( /[A-Za-z]{2}/ ) ) {
			  return null;
		  }
		  countries.add( countryArray[i].toUpperCase() );
	  }
	  
	  // Convert country set to array and sort alphabetically.
	  var validatedCountries = [];
	  countries.forEach( function( value ) {
		  validatedCountries.push( value );
	  } );
	  validatedCountries.sort();
	  	  
	  return validatedCountries;
  };
  
  $scope.getValidPayout = function( payout ) {
	  // If the value is not a valid float number then not valid.
	  var isFloatNum = /^[0-9.]+$/.test( payout );
	  if ( !isFloatNum ) {
		  return null;
	  }
	  
	  var p = parseFloat( payout );
	  if ( isNaN( p ) ) {
		  return null;
	  }
	  
	  // Range checking, payout must be positive float number no greater than a thousand.
	  if ( p < 0 || p > 1000 ) {
		  return null;
	  }
	  
	  return p;
  };
  
  $scope.getValidDailyCap = function( dailyCap ) {	  
	  // If cap is undefined, null, empty string, or zero then its essentially not set, so its invalid
	  if ( !dailyCap || dailyCap === "0" ) {
		  return null;
	  }
	  	  
	  // If the value is not a valid whole number then not valid.
	  var isWholeNum = /^[0-9]+$/.test( dailyCap );
	  if ( !isWholeNum ) {
		  return null;
	  }
	  
	  // Convert to a number.
	  var cap = parseInt( dailyCap );
	  if ( isNaN( cap ) ) {
		  return null;
	  }
	  
	  // Range checking, cap must be positive whole number no greater than a million.
	  if ( cap < 0 || cap > 1000000 ) {
		  return null;
	  }
	  	  
	  return cap;
  };

  $scope.getOwner = function( owner ) {
	if ( !owner ) {
		owner = "notset";
	}
	return owner;
  };

  
  $scope.createAndValidateInfo = function( reachPartner ) {
	  var countries, payout, dailyCap, platforms, owner;
	  
	  if ( $scope.existingClinkUpdate ) {
		  countries = $scope.getValidCountries( $scope.convertTagsToCountries() );
		  payout    = $scope.getValidPayout( $scope.existingClinkUpdate.p2p );
		  dailyCap  = $scope.getValidDailyCap( $scope.existingClinkUpdate.daily_cap );
		  platforms = $scope.getValidPlatforms( $scope.existingClinkUpdate );
		  // ROBXXX TODO
	  }
	  else {
		  countries = $scope.getValidCountries( reachPartner.countries );
		  payout    = $scope.getValidPayout( reachPartner.payout );
		  dailyCap  = $scope.getValidDailyCap( reachPartner.cap );
		  platforms = $scope.getValidPlatforms( reachPartner );
		  owner     = $scope.getOwner( reachPartner.owner );
	  }
	  	  
	  var messages = [];
	  if ( countries === null ) {
		  messages.push( 'Please specify valid Countries' + ( !$scope.existingClinkUpdate ? ' for ' + reachPartner.name : '' ) );
	  }
	  if ( platforms == null && ! $scope.ignorePlatforms ) {
		  messages.push( 'Please specify a Platform' + ( !$scope.existingClinkUpdate ? ' for ' + reachPartner.name : '' ) );
	  }
	  if ( payout === null ) {
		  messages.push( 'Please provide a valid Payout' + ( !$scope.existingClinkUpdate ? ' for ' + reachPartner.name : '' ) );
	  }
	  if ( dailyCap === null ) {
		  messages.push( 'Please enter a valid Daily Cap' + ( !$scope.existingClinkUpdate ? ' for ' + reachPartner.name : '' ) );
	  }
	  
	  // Now ensure that the specific countries are present on the selected campaigns.
	  if ( countries != null && countries !== 'ALL_FIELDS' ) {
		  var campaignCountries = $scope.campaignSummary.countries.split( ',' );
		  for ( let i = 0; i < countries.length; i++ ) {
			  var found = false;
			  for ( let j = 0; j < campaignCountries.length; j++ ) {
				  if ( countries[i] === campaignCountries[j] ) {
					  found = true;
					  break;
				  }
			  }
			  if ( !found ) {
				  messages.push( 'Specified ' + ( countries.length === 1 ? 'country' : 'countries' ) + 
					  ' not a country target for selected campaign(s)' + ( !$scope.existingClinkUpdate ? ' for ' + reachPartner.name : '' ) );
				  break;
			  }
		  }
	  }
	  
	  // Ensure the payouts are at least the minimum payout of the selected campaigns.
	  if ( payout != null ) {
		  if ( payout > $scope.campaignSummary.maxPayout ) {
			  messages.push( 'Payout to partner is more than the selected campaign payout' + ( !$scope.existingClinkUpdate ? ' for ' + reachPartner.name : '' ) );
		  }
	  }
	  
	  // If there is a total cap, ensure the cap is not greater than this amount.
	  if ( $scope.campaignSummary.totalCap !== 'None' ) {
		  var totalCap = parseInt( $scope.campaignSummary.totalCap );
		  if ( dailyCap > totalCap ) {
			  messages.push( 'The cap cannot be greater than the total cap for the selected campaigns' + ( !$scope.existingClinkUpdate ? ' for ' + reachPartner.name : '' ) );
		  }
	  }
	  
	  if ( messages.length > 0 ) {
		  return { "errors" : messages };
	  }
	  
	  var info = {
	       "platforms"   : platforms,
	       "dailyCap"    : dailyCap,
		   "owner"       : owner
	  };
	  
	  if ( !$scope.existingClinkUpdate ) {
		  info["pubID"] = reachPartner.publisherID;
		  info["siteID"] = reachPartner.siteID;
	      info["countries"] = countries;
	      info["payout"] = payout;
		  info["useRevShare"] = reachPartner.userevshare
		}
	  else {
	      info["countries"] = countries.join( ',' );
	      info["p2p"] = payout;
	  }
	  
	  info['ignorePlatforms'] = $scope.ignorePlatforms;
	  return info;
  };
  
  $scope.getCampaignIDs = function() {
	  var ret = [];
	  $scope.campaigns.forEach( function( camp ) {
		  if( camp.added ) {
			  ret.push( camp.supplySource + ':' + camp.campaignID );
		  }
	  });
	  return ret.join(',');
  };
  
  $scope.getPlatforms = function() {
	  return $scope._getPlatforms( $scope.platforms );
  };
  
  $scope._getPlatforms = function( platformsMap ) {
	  var ret = [];
	  if( platformsMap.android ) {
		  ret.push( 'android' );
	  }
	  if( platformsMap.iphone ) {
		  ret.push( 'iphone' );
	  }
	  if( platformsMap.ipad ) {
		  ret.push( 'ipad' );
	  }
	  return ret.join(',');
  };

  $scope.getAllowCounterBidOverride = function() {
	if ( $scope.allowCounterBidOverride === 'allow' ) {
		return true;
	}
	if ( $scope.allowCounterBidOverride === 'disable' ) {
	  return false;
	}
	return null;
  };

  $scope.getAllowCounterBid = function() {
	if ( $scope.allowCounterBid === 'allow' ) {
		return true;
	}
	if ( $scope.allowCounterBid === 'disable' ) {
		return false;
	}
	return null;
  };
  
  $scope.toggleAllCountries = function() {
  	  $scope.existingClinkUpdate.countries = null;
  };

  $scope.countryTagsUpdated = function() {
  	  $scope.existingClinkUpdate.allCountries = false;
  };
  
  $scope.convertCountriesToTags = function( countries ) {
	  if ( !countries ) {
		  return null;
	  }

	  if ( countries.indexOf( 'ALL_FIELDS' ) !== -1 ) {
		  $scope.existingClinkUpdate.allCountries = true;
	      return null;
	  } 
	  else {
		  $scope.existingClinkUpdate.allCountries = false;
	  }

	  var ret = countries.split( ',' );
	  _.map( ret, function( c ) {
		  return {
			 'text': c 
		  };
	  });

	  return ret;
  };
  
  $scope.convertTagsToCountries = function() {
  	  if ( $scope.existingClinkUpdate.allCountries ) {
  	  	return 'all';
  	  }
  	  
  	  if ( !$scope.existingClinkUpdate.countries ) {
  		  return null;
  	  }
  	  
	  var ret = [];
	  $scope.existingClinkUpdate.countries.forEach( function( tag ) {
		 ret.push( tag.text ); 
	  });
	  return ret.join(',');
  };
  
  $scope.insertCountry = function( c ) {
	  var exists = false;
	  $scope.countryTags.forEach( function(tag) {
		  if( tag.text === c ) {
			  exists = true;
		  }
	  });
	  if( !exists ) {
		  $scope.countryTags.push( {
			  'text':c
		  }); 
	  }
  };

  $scope.pastePopup = function() {
	var paste = $uibModal.open({
      templateUrl: 'views/create/pastePopup.html',
      controller: 'PastePopupCtrl'
    });
    
    paste.result.then( function( pasted ) {
    	var countries = pasted.split(',');
    	_.forEach( countries, function( c ) {
    		$scope.insertCountry( c );
    	});
    });
  };
  
  $scope.clearCountries = function() {
	  $scope.countryTags = [];  
  };
  
  $scope.addShortcut = function( sc ) {
	  if( !$scope.$storage.shortcuts || $scope.$storage.shortcuts === 'undefined' ) {
		  $scope.$storage.shortcuts = [];
	  }
	  if( sc !== null && sc !== undefined && sc !== '' && jQuery.inArray(sc, $scope.$storage.shortcuts) === -1 ) {
	  	  if( sc.length === 2 ) {
		  	$scope.$storage.shortcuts.push( sc.toUpperCase() );
		  }
	  }
  };

  $scope.tagAdded = function( tag ) {
  	  tag.text = tag.text.toUpperCase();
  };
  
  $scope.removeReachPartner = function( reachPartner ) {
	  reachPartner.included = false;
  };
  
  $scope.showCampaignsForClink = function( clink ) {
	  // Find the configured campaigns for this clink from the "all" campaigns list.
	  //clink.configs[0].campaigns[];  // source, campaign_id
	  var configuredCampagins = [];
	  for ( let i = 0; i < clink.configs[0].campaigns.length; i++ ) {
		  var source = clink.configs[0].campaigns[i].source;
		  var campaignID = clink.configs[0].campaigns[i].campaign_id;
		  
		  var foundCampaign = null;
		  for ( let j = 0; j < allCampaigns.length; j++ ) {
			  if ( allCampaigns[j].supplySource === source && allCampaigns[j].campaignID === campaignID ) {
				  foundCampaign = allCampaigns[j];
				  break;
			  }
		  }
		  
		  if ( foundCampaign ) {
			  configuredCampagins.push( foundCampaign );
		  }
		  else {
			  // No current campaign exists anymore.
			  configuredCampagins.push( {
				  status : "NONE",
				  supplySource : source,
				  campaignID : campaignID,
				  noExists : true
			  } );
		  }
	  }
	  
	  $scope.selectedExistingClink = {
	      clink : clink,
	      configuredCampagins : configuredCampagins
	  };
      ngDialog.open( {
          template: './clink_modification/views/create/existing-clink-campaigns.html',
    	  scope: $scope
      } );
  };
  
  $scope.addReachPartner = function() {
	  var reachPartnerSelect = document.getElementById( "reachPartnerSelect" );
	  var selected = reachPartnerSelect.options[ reachPartnerSelect.selectedIndex ].value;
	  
	  for ( let i = 0; i < $scope.reachPartners.length; i++ ) {
		  if ( $scope.reachPartners[i].name === selected ) {
			  $scope.reachPartners[i].included = true;
			  break;
		  }
	  }
  };
  
  /**
   * Bases the cLink configuration data: countries, pay-out, and cap on the currently selected campaigns. The method will determine the
   * appropriate settings based on all the currently selected campaigns.
   */
  $scope.updateReachPartnerConfigsAndCampaignSummary = function() {
	  var campaignNum = 0;
	  var minPayout = 0.0;
	  var maxPayout = 0.0;
	  var countries = new Set();
	  var cap = 0;
	  var unlimitedCap = false;
	  var osVersion = null;
	  var incent = false;
	  var platforms = { 
		  'android' : false,
		  'iphone'  : false,
		  'ipad'    : false
	  };
	  
	  for ( let i = 0; i < $scope.campaigns.length; i++ ) {
		  if ( $scope.campaigns[i].added ) {
			  campaignNum++;
			  
			  if ( $scope.campaigns[i].incent ) {
				  incent = true;
			  }
			  
			  // Payout is based on min payout of selected campaigns.
			  if ( minPayout === 0.0 ) {
				  minPayout = $scope.campaigns[i].payout;
				  maxPayout = $scope.campaigns[i].payout;
			  }
			  else {
				  minPayout = Math.min( minPayout, $scope.campaigns[i].payout );
				  maxPayout = Math.max( maxPayout, $scope.campaigns[i].payout );
			  }
			  
			  // Country is based on a union of countries of selected campaigns.
			  var countriesArray = $scope.campaigns[i].countries.split( ',' );
			  for ( let j = 0; j < countriesArray.length; j++ ) {
				  countries.add( countriesArray[j] );
			  }
			  
			  // Cap is a sum of selected campaigns.
			  if ( $scope.campaigns[i].dailyInstallCap && $scope.campaigns[i].dailyInstallCap > 0 ) {
				  cap = cap + $scope.campaigns[i].dailyInstallCap;
			  }
			  else {
				  unlimitedCap = true;
			  }
			  
			  // Determine the platforms for this campaign.
	    	  if ( $scope.campaigns[i].platforms.indexOf( 'android' ) >= 0 ) {
	    		  platforms.android = true;
	    	  }
	    	  if ( $scope.campaigns[i].platforms.indexOf( 'iphone' ) >= 0 ) {
	    		  platforms.iphone = true;
	    	  }
	    	  if ( $scope.campaigns[i].platforms.indexOf( 'ipad' ) >= 0 ) {
	    		  platforms.ipad = true;
	    	  }
	    	  
	    	  // Determine the min OS Version which is the "greatest" of the selected campaigns.
	    	  if ( $scope.campaigns[i].osVersion !== "Any" ) {
	    		  if ( !osVersion ) {
	    			  osVersion = $scope.campaigns[i].osVersion;
	    		  }
	    		  else {
	    			  if ( $scope.isGreaterOSVersion( osVersion, $scope.campaigns[i].osVersion ) ) {
	    				  osVersion = $scope.campaigns[i].osVersion;
	    			  }
	    		  }
	    	  }
		  }
	  }
	  
	  // Convert country set to array and sort alphabetically.
	  countriesArray = [];
	  countries.forEach( function( value ) {
		  countriesArray.push( value );
	  } );
	  countriesArray.sort();
	  var countriesString = countriesArray.join( ',' );

	  // Populate the "all" information.  For payout use the default split of 70%.
	  $scope.all.payout = minPayout;
	  $scope.all.countryTags = countriesString;
	  $scope.all.dailyCap = null;  // No default daily cap, must be specified by the user.
	  $scope.all.android = platforms.android;
	  $scope.all.iphone = platforms.iphone;
	  $scope.all.ipad = platforms.ipad;
	  
	  // Determine the margin info text which can show either a single value or a range.
	  $scope.all.margin = $scope.determineMarginInfo( $scope.defaultReachPartnerSplit, $scope.all.payout, minPayout, maxPayout ); 
	  
	  // Populate the "campaign summary" information.
	  if ( campaignNum > 0 ) {
		  $scope.campaignSummary.numberOfCampaigns = campaignNum;
		  $scope.campaignSummary.platforms = $scope._getPlatforms( platforms );
		  $scope.campaignSummary.countries = countriesString;
		  $scope.campaignSummary.totalCap = ( unlimitedCap ? "None" : cap );
		  $scope.campaignSummary.osVersion = ( osVersion ? osVersion : "Any" );
		  $scope.campaignSummary.incent = incent;
		  
		  $scope.campaignSummary.minPayout = minPayout;
		  $scope.campaignSummary.maxPayout = maxPayout;
		  if ( minPayout !== maxPayout ) {
			  $scope.campaignSummary.payoutRange = $filter( 'currency' )( minPayout, '$' ) + " - " + $filter( 'currency' )( maxPayout, '$' );
		  }
		  else {
			  $scope.campaignSummary.payoutRange = $filter( 'currency' )( minPayout, '$' );
		  }
	  }
	  else {
		  $scope.campaignSummary.numberOfCampaigns = 0;
		  $scope.campaignSummary.platforms = 'None';
		  $scope.campaignSummary.countries = 'None';
		  $scope.campaignSummary.totalCap = 'None';
		  $scope.campaignSummary.payoutRange = 'None';
		  $scope.campaignSummary.osVersion = 'None';
		  $scope.campaignSummary.incent = false;
	  }
	  
	  $scope.updateReachPartnerData( null, minPayout, maxPayout );
  };  
  
  $scope.isGreaterOSVersion = function( baseVersion, newVersion ) {
	  try {
		  var b = baseVersion.replace( /[+\-=]/, "" ).split( "." );
		  var n = newVersion.replace( /[+\-=]/, "" ).split( "." );
		  
		  var baseMajor = parseInt( b[0] );
		  var baseMinor = b[1] ? parseInt( b[1] ) : 0;
		  var baseRevision = b[2] ? parseInt( b[2] ) : 0;
		  
		  var newMajor = parseInt( n[0] );
		  var newMinor = n[1] ? parseInt( n[1] ) : 0;
		  var newRevision = n[2] ? parseInt( n[2] ) : 0;
		  
		  // Compare major
		  if ( newMajor < baseMajor ) {
			  return false;
		  }
		  if ( newMajor > baseMajor ) {
			  return true;
		  }
		  
		  // Compare minor
		  if ( newMinor < baseMinor ) {
			  return false;
		  }
		  if ( newMinor > baseMinor ) {
			  return true;
		  }
		  
		  // Compare revision
		  if ( newRevision < baseRevision ) {
			  return false;
		  }
		  if ( newRevision > baseRevision ) {
			  return true;
		  }
		  
		  return false;
	  }
	  catch ( exception ) {
		  console.error( "Problem handling OS version: " + exception.message );
		  return false;
	  }
  };
  
  $scope.getButtonClass = function( campaign ) {
	  if( campaign.added ) {
		  return 'btn-danger';
	  }
	  return 'btn-success';
  };
  
  $scope.isSelected = function( pubid, siteid, pubsite ) {
	  return (pubid + ':' + siteid) === pubsite;
  };  
}]);


angular.module('clinkModification')
.controller('PastePopupCtrl', ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {

	$scope.data = {
		pasted : null
	};

	$scope.ok = function() {
		$uibModalInstance.close( $scope.data.pasted );
	};

	$scope.cancel = function() {
		$uibModalInstance.dismiss('cancel');
	};
}]);
